
  <div class="modal-header">
      <h4 class="modal-title">{{title}}</h4>
  </div>
  <div class="modal-body row d-flex justify-content-center">
    <div class="rounded-box signature-area">

      <canvas #signature width="500" height="200" style="height: 100%; width: 100%;"></canvas>
    </div>
  </div>
  <img #sigImg >
  <div class="modal-footer">
      <button type="submit" class="btn btn-secondary" (click)="clearSignature()">Clear</button>
      <button type="submit" class="btn btn-success" (click)="saveSignature()">Sign</button>
      <button type="button" class="btn btn-info" (click)="cancel()">Cancel</button>
  </div>

